import { Paper, Stack } from "@mui/material";
import React from "react";
import styled from "styled-components";
import AnalysisHistoryTable from "src/scenes/causal-analysis/components/analysis-history-table";
import analysisHistoryMockData from "src/scenes/causal-analysis/components/analysis-history-mock-data";

const HistoryPaper = styled(Paper)`
    min-height: 300px;
    width: 97%;
    border-radius: 0px 0px 14px 14px;
    margin-bottom: 32px;
`;

const PaperTitle = styled.p`
    margin: 0;
    padding: 7px 0 6px 18px;
    font-size: 12px;
`;

const HistorySection = () => {
    return (
        <HistoryPaper style={{ height: "120px", width: "97%" }}>
            <Stack direction="column">
                <PaperTitle>Analysis History</PaperTitle>
                <AnalysisHistoryTable data={analysisHistoryMockData.pastAnalyses} />
            </Stack>
        </HistoryPaper>
    );
};

export default HistorySection;
